import type { LocaleMessageBundle } from '../../types'

export const staffShiftMessages: LocaleMessageBundle = {
  vi: {
    'staff.shift.actions.previousWeek': 'Tuần trước',
    'staff.shift.actions.nextWeek': 'Tuần sau',
    'staff.shift.actions.removeStaff': 'Bỏ nhân viên',
    'staff.shift.actions.assign': 'Phân ca',
    'staff.shift.actions.add': 'Thêm ca',
    'staff.shift.actions.addStaff': 'Thêm nhân viên',
    'staff.shift.actions.confirm': 'Xác nhận',
    'staff.shift.actions.delete': 'Xóa',
    'staff.shift.actions.today': 'Hôm nay',
    'staff.shift.tabs.schedule': 'Lịch phân ca',
    'staff.shift.tabs.catalog': 'Danh mục ca',
    'staff.shift.tabs.batches': 'Phân ca nhanh',
    'staff.shift.search.schedule': 'Tìm theo tên nhân viên',
    'staff.shift.search.shift': 'Tìm mã hoặc tên ca',
    'staff.shift.search.staff': 'Tìm theo tên, mã hoặc số điện thoại',
    'staff.shift.empty.staff': 'Không tìm thấy nhân viên',
    'staff.shift.empty.selectedStaff': 'Chưa có nhân viên nào được chọn',
    'staff.shift.fields.staff': 'Nhân viên',
    'staff.shift.fields.employeeCode': 'Mã nhân viên',
    'staff.shift.fields.fullName': 'Họ và tên',
    'staff.shift.fields.phone': 'Điện thoại',
    'staff.shift.fields.gender': 'Giới tính',
    'staff.shift.fields.department': 'Bộ phận',
    'staff.shift.fields.code': 'Mã ca',
    'staff.shift.fields.name': 'Tên ca',
    'staff.shift.fields.timeRange': 'Khung giờ',
    'staff.shift.fields.breakMinutes': 'Nghỉ (phút)',
    'staff.shift.fields.duration': 'Thời lượng',
    'staff.shift.fields.futureAssignments': 'Lịch sắp tới',
    'staff.shift.fields.status': 'Trạng thái',
    'staff.shift.fields.listName': 'Tên danh sách',
    'staff.shift.fields.dateRange': 'Khoảng ngày',
    'staff.shift.fields.workdays': 'Ngày làm việc',
    'staff.shift.fields.scheduleCount': 'Số lịch',
    'staff.shift.fields.startTime': 'Giờ bắt đầu',
    'staff.shift.fields.endTime': 'Giờ kết thúc',
    'staff.shift.fields.breakTime': 'Thời gian nghỉ (phút)',
    'staff.shift.fields.color': 'Màu hiển thị',
    'staff.shift.fields.note': 'Ghi chú',
    'staff.shift.fields.shift': 'Ca làm việc',
    'staff.shift.fields.displayName': 'Tên ca hiển thị',
    'staff.shift.fields.start': 'Bắt đầu',
    'staff.shift.fields.end': 'Kết thúc',
    'staff.shift.fields.fromDate': 'Từ ngày',
    'staff.shift.fields.toDate': 'Đến ngày',
    'staff.shift.fields.weekdays': 'Ngày làm việc trong tuần',
    'staff.shift.hints.codeAuto': 'Để trống để hệ thống tự tạo mã ca',
    'staff.shift.status.active': 'Hoạt động',
    'staff.shift.status.inactive': 'Tạm ngưng',
    'staff.shift.gender.male': 'Nam',
    'staff.shift.gender.female': 'Nữ',
    'staff.shift.gender.other': 'Khác',
    'staff.shift.department.uncategorized': 'Chưa phân loại',
    'staff.shift.weekday.1': 'Thứ 2',
    'staff.shift.weekday.2': 'Thứ 3',
    'staff.shift.weekday.3': 'Thứ 4',
    'staff.shift.weekday.4': 'Thứ 5',
    'staff.shift.weekday.5': 'Thứ 6',
    'staff.shift.weekday.6': 'Thứ 7',
    'staff.shift.weekday.7': 'Chủ nhật',
    'staff.shift.units.day': '+1 ngày',
    'staff.shift.units.minutes': '{count} phút',
    'staff.shift.units.staff': '{count} nhân viên',
    'staff.shift.dialog.createShift': 'Thêm ca làm việc',
    'staff.shift.dialog.updateShift': 'Cập nhật ca',
    'staff.shift.dialog.assign': 'Phân ca nhân viên',
    'staff.shift.dialog.updateAssignment': 'Cập nhật phân ca',
    'staff.shift.dialog.pickStaff': 'Chọn nhân viên',
    'staff.shift.selected.title': 'Danh sách được phân ca',
    'staff.shift.picker.departmentHint':
      'Toàn bộ nhân viên đang hoạt động của các bộ phận được chọn tại chi nhánh hiện tại sẽ được thêm vào danh sách.',
    'staff.shift.picker.selectDepartment': 'Chọn bộ phận',
    'staff.shift.confirm.deleteShift': 'Xóa ca {name}?',
    'staff.shift.confirm.deleteBatch': 'Xóa toàn bộ danh sách {name}?',
    'staff.shift.defaultBatchName': 'Phân ca nhanh',
    'staff.shift.validation.codeMax': 'Mã ca không được vượt quá 100 ký tự',
    'staff.shift.validation.nameRequired': 'Vui lòng nhập tên ca',
    'staff.shift.validation.nameMax': 'Tên ca không được vượt quá 255 ký tự',
    'staff.shift.validation.noteMax': 'Ghi chú không được vượt quá 500 ký tự',
    'staff.shift.validation.breakNumber': 'Thời gian nghỉ phải là số nguyên',
    'staff.shift.validation.breakMin': 'Thời gian nghỉ phải lớn hơn hoặc bằng 0 phút',
    'staff.shift.validation.breakMax': 'Thời gian nghỉ không được vượt quá 1440 phút',
    'staff.shift.validation.breakLessThanShift': 'Thời gian nghỉ phải nhỏ hơn thời lượng ca',
    'staff.shift.validation.breakHint': '0–1440 phút và phải nhỏ hơn thời lượng ca',
    'staff.shift.validation.timeRequired': 'Vui lòng nhập thời gian làm việc',
    'staff.shift.validation.branchRequired': 'Vui lòng chọn chi nhánh trước khi thêm ca.',
    'staff.shift.validation.requiredFields': 'Vui lòng nhập đầy đủ tên ca và thời gian làm việc.',
    'staff.shift.validation.differentTimes': 'Giờ bắt đầu và giờ kết thúc phải khác nhau.',
    'staff.shift.validation.staffRequired': 'Vui lòng chọn ít nhất một nhân viên.',
    'staff.shift.validation.dateRange': 'Ngày kết thúc phải sau hoặc bằng ngày bắt đầu.',
    'staff.shift.validation.weekdayRequired': 'Vui lòng chọn ít nhất một ngày làm việc.',
    'staff.shift.validation.scheduleLimit':
      'Tổng số lịch cần tạo là {count}. Mỗi lần chỉ được tạo tối đa 200 lịch.',
    'staff.shift.notifications.createFailed': 'Thêm phân ca không thành công.',
    'staff.shift.notifications.updateFailed': 'Cập nhật phân ca không thành công.',
    'staff.shift.notifications.createShiftFailed': 'Thêm ca làm việc không thành công.',
    'staff.shift.notifications.updateShiftFailed': 'Cập nhật ca làm việc không thành công.',
    'staff.shift.errors.shift_overlap': 'Ca làm việc có thời gian trùng với ca trước đó.',
    'staff.shift.errors.shift_duration_invalid': 'Thời lượng ca làm việc không hợp lệ.',
    'staff.shift.errors.staff_inactive': 'Nhân viên đang ngừng hoạt động.',
    'staff.shift.errors.staff_not_assigned_to_branch': 'Nhân viên không thuộc chi nhánh này.',
    'staff.shift.errors.shift_inactive': 'Mẫu ca làm việc đang ngừng hoạt động.',
    'staff.shift.errors.past_shift_change_forbidden': 'Không thể thay đổi ca làm việc trong quá khứ.',
    'staff.shift.errors.branch_immutable': 'Không thể thay đổi chi nhánh của mẫu ca.',
    'staff.shift.errors.has_future_assignments':
      'Không thể xóa mẫu ca đang có lịch làm việc trong tương lai.',
    'staff.shift.errors.break_invalid': 'Thời gian nghỉ không hợp lệ.',
    'staff.shift.errors.assignment_has_attendance':
      'Ca đã có dữ liệu chấm công.',
  },
  en: {
    'staff.shift.actions.previousWeek': 'Previous week',
    'staff.shift.actions.nextWeek': 'Next week',
    'staff.shift.actions.removeStaff': 'Remove staff',
    'staff.shift.actions.assign': 'Assign shifts',
    'staff.shift.actions.add': 'Add shift',
    'staff.shift.actions.addStaff': 'Add staff',
    'staff.shift.actions.confirm': 'Confirm',
    'staff.shift.actions.delete': 'Delete',
    'staff.shift.actions.today': 'Today',
    'staff.shift.tabs.schedule': 'Shift schedule',
    'staff.shift.tabs.catalog': 'Shift catalog',
    'staff.shift.tabs.batches': 'Quick assignment',
    'staff.shift.search.schedule': 'Search by staff name',
    'staff.shift.search.shift': 'Search by shift code or name',
    'staff.shift.search.staff': 'Search by name, code, or phone number',
    'staff.shift.empty.staff': 'No staff found',
    'staff.shift.empty.selectedStaff': 'No staff selected',
    'staff.shift.fields.staff': 'Staff',
    'staff.shift.fields.employeeCode': 'Employee code',
    'staff.shift.fields.fullName': 'Full name',
    'staff.shift.fields.phone': 'Phone',
    'staff.shift.fields.gender': 'Gender',
    'staff.shift.fields.department': 'Department',
    'staff.shift.fields.code': 'Shift code',
    'staff.shift.fields.name': 'Shift name',
    'staff.shift.fields.timeRange': 'Time range',
    'staff.shift.fields.breakMinutes': 'Break (minutes)',
    'staff.shift.fields.duration': 'Duration',
    'staff.shift.fields.futureAssignments': 'Upcoming schedules',
    'staff.shift.fields.status': 'Status',
    'staff.shift.fields.listName': 'List name',
    'staff.shift.fields.dateRange': 'Date range',
    'staff.shift.fields.workdays': 'Workdays',
    'staff.shift.fields.scheduleCount': 'Schedules',
    'staff.shift.fields.startTime': 'Start time',
    'staff.shift.fields.endTime': 'End time',
    'staff.shift.fields.breakTime': 'Break time (minutes)',
    'staff.shift.fields.color': 'Display color',
    'staff.shift.fields.note': 'Note',
    'staff.shift.fields.shift': 'Work shift',
    'staff.shift.fields.displayName': 'Display shift name',
    'staff.shift.fields.start': 'Start',
    'staff.shift.fields.end': 'End',
    'staff.shift.fields.fromDate': 'From date',
    'staff.shift.fields.toDate': 'To date',
    'staff.shift.fields.weekdays': 'Workdays of the week',
    'staff.shift.hints.codeAuto': 'Leave blank to generate the shift code automatically',
    'staff.shift.status.active': 'Active',
    'staff.shift.status.inactive': 'Inactive',
    'staff.shift.gender.male': 'Male',
    'staff.shift.gender.female': 'Female',
    'staff.shift.gender.other': 'Other',
    'staff.shift.department.uncategorized': 'Uncategorized',
    'staff.shift.weekday.1': 'Monday',
    'staff.shift.weekday.2': 'Tuesday',
    'staff.shift.weekday.3': 'Wednesday',
    'staff.shift.weekday.4': 'Thursday',
    'staff.shift.weekday.5': 'Friday',
    'staff.shift.weekday.6': 'Saturday',
    'staff.shift.weekday.7': 'Sunday',
    'staff.shift.units.day': '+1 day',
    'staff.shift.units.minutes': '{count} min',
    'staff.shift.units.staff': '{count} staff',
    'staff.shift.dialog.createShift': 'Add work shift',
    'staff.shift.dialog.updateShift': 'Update shift',
    'staff.shift.dialog.assign': 'Assign staff shifts',
    'staff.shift.dialog.updateAssignment': 'Update assignment',
    'staff.shift.dialog.pickStaff': 'Select staff for shifts',
    'staff.shift.selected.title': 'Assigned staff list',
    'staff.shift.picker.departmentHint':
      'All active staff in the selected departments at the current branch will be added to the list.',
    'staff.shift.picker.selectDepartment': 'Select departments',
    'staff.shift.confirm.deleteShift': 'Delete shift {name}?',
    'staff.shift.confirm.deleteBatch': 'Delete the entire list {name}?',
    'staff.shift.defaultBatchName': 'Quick assignment',
    'staff.shift.validation.codeMax': 'Shift code must not exceed 100 characters',
    'staff.shift.validation.nameRequired': 'Please enter a shift name',
    'staff.shift.validation.nameMax': 'Shift name must not exceed 255 characters',
    'staff.shift.validation.noteMax': 'Note must not exceed 500 characters',
    'staff.shift.validation.breakNumber': 'Break time must be a whole number',
    'staff.shift.validation.breakMin': 'Break time must be at least 0 minutes',
    'staff.shift.validation.breakMax': 'Break time must not exceed 1440 minutes',
    'staff.shift.validation.breakLessThanShift':
      'Break time must be shorter than the shift duration',
    'staff.shift.validation.breakHint': '0–1440 minutes and shorter than the shift duration',
    'staff.shift.validation.timeRequired': 'Please enter the working time',
    'staff.shift.validation.branchRequired': 'Please select a branch before adding a shift.',
    'staff.shift.validation.requiredFields': 'Please enter the shift name and working time.',
    'staff.shift.validation.differentTimes': 'Start and end times must be different.',
    'staff.shift.validation.staffRequired': 'Please select at least one staff member.',
    'staff.shift.validation.dateRange': 'The end date must be on or after the start date.',
    'staff.shift.validation.weekdayRequired': 'Please select at least one workday.',
    'staff.shift.validation.scheduleLimit':
      'The total number of schedules is {count}. You can create up to 200 schedules at a time.',
    'staff.shift.notifications.createFailed': 'Failed to assign shift.',
    'staff.shift.notifications.updateFailed': 'Failed to update shift assignment.',
    'staff.shift.notifications.createShiftFailed': 'Failed to create work shift.',
    'staff.shift.notifications.updateShiftFailed': 'Failed to update work shift.',
    'staff.shift.errors.shift_overlap': 'The work shift time overlaps with a previous shift.',
    'staff.shift.errors.shift_duration_invalid': 'Shift duration is invalid.',
    'staff.shift.errors.staff_inactive': 'Staff member is inactive.',
    'staff.shift.errors.staff_not_assigned_to_branch': 'Staff member is not assigned to this branch.',
    'staff.shift.errors.shift_inactive': 'Work shift template is inactive.',
    'staff.shift.errors.past_shift_change_forbidden': 'Cannot modify past shifts.',
    'staff.shift.errors.branch_immutable': 'Cannot change the branch of this shift.',
    'staff.shift.errors.has_future_assignments':
      'Cannot delete a shift with future assignments.',
    'staff.shift.errors.break_invalid': 'Break time is invalid.',
    'staff.shift.errors.assignment_has_attendance':
      'This shift already has attendance records.',
  },
}
